import React from 'react';
import { IApplicationContext } from '../IApplicationContext';

export const EidApplicationContext = React.createContext<IApplicationContext>(undefined as any);
